import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AlertService } from "../services/alert.service";
import { EnvService } from "../services/env.service";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "../services/auth.service";

@Component({
  selector: "micro-osFamily-detail",
  templateUrl: "./os-family-detail.component.html",
})
export class OsFamilyDetailComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  @Input() osId: any;
  @Output() persisted = new EventEmitter<any>();
  
  osFamily: any;
  osTypeName: any = '';
  selectedOsType: any;

  constructor(
    public auth: AuthService,
    private env: EnvService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    if (this.osId) {
      this.load(this.osId);
    } else {
      this.route.params.subscribe((params: Params) => {
        params["id"] === "0" ? this.createNew() : this.load(params["id"]);
      });
    }
  }

  load(id: string): void {
    this.http
      .get(`${this.env.e.url}/domain/cmdbOsFamily/${id}`)
      .subscribe((data) => {
        this.osFamily = data;
      });
  }

  createNew(): void {
    this.osFamily = { code: "", name: "", description: "None", active: "N", osTypeId: "", companyId: this.auth.getCompanyId() };
  }

  save(): void {
    const isUpdate = !!this.osFamily.id;
    const request = isUpdate
      ? this.http.put(
          `${this.env.e.url}/domain/cmdbOsFamily/${this.osFamily.id}`,
          this.osFamily,
        )
      : this.http.post(`${this.env.e.url}/domain/cmdbOsFamily`, this.osFamily);
    request.subscribe((data) => {
      this.osFamily = data;
      this.alertService.info(
        `${isUpdate ? "Updated" : "Created"} ${this.osFamily.name}`,
      );
      this.persisted.emit({ data, action: isUpdate ? "updated" : "added" });
    });
  }

  delete(): void {
    this.http
      .delete(`${this.env.e.url}/domain/cmdbOsFamily/${this.osFamily.id}`)
      .subscribe(() => {
        this.persisted.emit({ data: this.osFamily, action: "deleted" });
        this.alertService.info(`Deleted ${this.osFamily.name}`);
        if (!this.osFamily.id) {
          this.router.navigate(["/os"]);
        }
      });
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.osFamily.active = target.checked ? "Y" : "N";
  }

  onOsTypeChange(osType: any): void {
    this.selectedOsType = osType;
    this.osTypeName = osType ? osType.name : '';
  }
}
